/**
 * vion-icon v1.0.1
 * (c) 2023 yangling
 * @license MIT
 */

import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, createElementVNode } from 'vue';

var Like = defineComponent({
  name: "Like",
  props: {
    color: String,
    size: String
  },
  emits: ["click"],
  setup: function setup(props, ctx) {
    var iconStyle = computed(function () {
      return {
        display: "inline-block",
        fontSize: props.size,
        color: props.color,
        width: "1em",
        height: "1em",
        lineHeight: "1em"
      };
    });
    var click = function click(e) {
      return ctx.emit("click", e);
    };
    return {
      iconStyle: iconStyle,
      click: click
    };
  }
});
Like.install = function (app) {
  app.component(Like.name, Like);
};

var _hoisted_1 = /* @__PURE__ */createElementVNode("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [/* @__PURE__ */createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3 16.14C3 9.37889 8.63126 4 15.45 4C18.7523 4 21.7652 5.25612 24 7.31526C26.2348 5.25612 29.2477 4 32.55 4C39.3687 4 45 9.37889 45 16.14C45 19.1166 43.8993 21.8407 42.0865 23.9449C39.4211 27.3949 35.2011 31.5496 31.7156 34.7911C29.9507 36.4325 28.3479 37.8637 27.1861 38.8848C26.605 39.3955 26.1335 39.8042 25.8066 40.0859C25.6431 40.2268 25.5157 40.3359 25.4286 40.4103L25.329 40.4952L25.2941 40.5249C25.2939 40.5251 25.2932 40.5257 24 39C22.6908 40.512 22.6907 40.5119 22.6906 40.5117L22.6537 40.4798L22.5491 40.3888C22.4578 40.3092 22.3239 40.1922 22.1522 40.0416C21.809 39.7405 21.3147 39.3046 20.7081 38.7635C19.4954 37.6818 17.8309 36.1774 16.0246 34.4868C12.4698 31.1596 8.2352 26.9913 5.88041 23.9063C4.08732 21.8075 3 19.0984 3 16.14ZM24 39L22.6906 40.5117L23.9861 41.6335L25.2932 40.5257L24 39ZM24.0114 36.348C24.1764 36.204 24.3549 36.0478 24.5455 35.8802C25.6866 34.8774 27.2605 33.4719 28.9916 31.862C32.4826 28.6154 36.5091 24.6321 38.9527 21.4585L38.9893 21.4109L39.0288 21.3656C40.2649 19.9454 41 18.1244 41 16.14C41 11.7007 37.274 8 32.55 8C29.6681 8 27.1406 9.38599 25.6187 11.4831L24 13.7135L22.3813 11.4831C20.8594 9.38599 18.3319 8 15.45 8C10.726 8 7 11.7007 7 16.14C7 18.113 7.72669 19.9243 8.94982 21.3409L8.99071 21.3882L9.02856 21.4381C11.1436 24.222 15.1651 28.2035 18.758 31.5664C20.535 33.2296 22.1749 34.7118 23.3706 35.7784C23.6016 35.9844 23.816 36.1749 24.0114 36.348Z",
  fill: "currentColor"
})], -1);
var _hoisted_2 = [_hoisted_1];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", {
    class: "v-icon",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.click && _ctx.click.apply(_ctx, arguments);
    }),
    style: normalizeStyle(_ctx.iconStyle)
  }, _hoisted_2, 4);
}

Like.render = render;

export { Like as default };
